import React from "react";
import styled from "styled-components";

const OrWrapper = styled.div`
    text-align: center;
    padding: 15px 0 20px;
`;

export default OrWrapper;
